// @mui
import { Container, Grid } from '@mui/material';

import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores/store';

//Localization
import useLocales from 'src/hooks/useLocales';
import Page from 'src/components/Page';
import useSettings from 'src/hooks/useSettings';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import { PATH_DASHBOARD } from 'src/routes/paths';
import FloorDetailTableRow from './FloorDetailTableRow';
import { useEffect, useState } from 'react';
import Loader from 'src/components/loader/Loader';
// ----------------------------------------------------------------------
export default observer(function FloorDetailHeader() {
  const { translate } = useLocales();
  const {
    FloorStore: { selectedFloorDetail, clearSelectedFloor, loadFloorDetail, ID },
  } = useStore();

  const [isLoading, setIsLoading] = useState(true); // Track loading state

  useEffect(() => {
    if (ID) {
      setIsLoading(true);
      loadFloorDetail(ID).finally(() => setIsLoading(false)); // Ensure loading ends
    }
  }, [loadFloorDetail, ID]);

  const { themeStretch } = useSettings();

  // Handle case when no ID or data is available
  if (!ID) {
    return (
      <Page title={translate('Floor.FloorDetails')}>
        <Container maxWidth={themeStretch ? false : 'lg'}>
          <HeaderBreadcrumbs
            heading={translate('Floor.FloorDetails')}
            links={[
              { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },
              { name: `${translate('Floor.FloorDetails')}`, href: PATH_DASHBOARD.Floor.list },
            ]}
          />
          <p>{translate('Floor.NoData')}</p>
        </Container>
      </Page>
    );
  }

  return (
    <Page title={translate('Floor.FloorDetails')}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={translate('Floor.FloorDetails')}
          links={[
            { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },
            { name: `${translate('Floor.FloorDetails')}`, href: PATH_DASHBOARD.Floor.list },
          ]}
        />
        {isLoading ? ( // Show loading state
          <Grid container justifyContent="center" alignItems="center" style={{ height: '50vh' }}>
              <Loader />
          </Grid>
        ) : selectedFloorDetail ? ( // Render details if available
          <Grid container>
            <FloorDetailTableRow row={selectedFloorDetail} clearFloor={clearSelectedFloor} />
          </Grid>
        ) : (
          <Grid container justifyContent="center" alignItems="center" style={{ height: '50vh' }}>
            <p>{translate('Floor.NoData')}</p>
          </Grid>
        )}
      </Container>
    </Page>
  );
});
